import { styled } from '@mui/material';

export const Hr = styled('hr')(({ theme }) => ({
	margin: '0',
	border: 'none',
	width: '100%',
	height: '1px',
	background: theme.palette.primary.main,
	opacity: 0.2,
}));

export const Description = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});

export const StudentWrap = styled('div')({
	display: 'flex',
	gap: '4px',
});
